import React from 'react';
import { useCountryStore } from '@/stores/CountriesStore';
import { Icon } from "@iconify/react";
import { useTranslation } from 'react-i18next';

type CountryFlagProps = {
    countryId: number;
    showPrefix?: boolean;
};

const CountryFlag: React.FC<CountryFlagProps> = ({ countryId, showPrefix = true }) => {
    const countryStore = useCountryStore();
    const src = countryStore.countriesById[countryId]?.image_path || null;
    const countryName = countryStore.countriesById[countryId]?.name || '';
    const { t } = useTranslation();

    return (
        countryName ?
            (
                <div className='flex items-center gap-2 text-nowrap overflow-ellipsis'>
                    {src && <img src={src} style={{ width: '24px' }}></img>}
                    {showPrefix && <span className='text-default-500 text-sm font-medium truncate'>{countryName}</span>}
                </div>
            )
            : (
                <div className='flex items-center gap-2 text-nowrap overflow-ellipsis'>
                    <Icon
                        className="text-default-500"
                        icon="solar:earth-linear"
                        width={24}
                    />
                    <span className='text-default-500 text-sm font-medium truncate'>{t('names.names_63')}</span>
                </div>
            )
    );
};

export default CountryFlag;
